import { useState } from 'react';
import { useTranslation } from '~/_shared/utils/hooks';
import type {
  CreateMapErrorResponse, CreateMapSuccessResponse,
} from '../map.repository';
import {
  createBlankMap, getGeneralCreateMapErrorMessage,
} from './createNewMap.helpers';

export const useCreateBlankMap = (clientId: number | null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [t] = useTranslation();

  const resetState = () => {
    setIsLoading(false);
    setErrorMessage('');
  };

  const onCreateBlankMap = (mapName: string, mapDescription: string, onSuccess: (mapId: number) => void) => {
    if (clientId === null) {
      return;
    }

    setIsLoading(true);
    createBlankMap(clientId, mapName, mapDescription)
      .then((response: CreateMapSuccessResponse) => {
        onSuccess(response.data.id);
      })
      .catch((e: CreateMapErrorResponse) => {
        setErrorMessage(getGeneralCreateMapErrorMessage(e, t));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    errorMessage,
    resetState,
    isLoading,
    createBlankMap: onCreateBlankMap,
  };
};
